import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/manga';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setCategoryOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className="text-xl md:text-2xl font-bold text-primary-500 font-heading">
              韩漫大全
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors hover:text-primary-500 whitespace-nowrap ${
                location.pathname === '/' ? 'text-primary-500' : 'text-foreground-700'
              }`}
            >
              首页
            </Link>

            <div className="relative">
              <button
                onClick={() => setCategoryOpen(!categoryOpen)}
                className={`flex items-center gap-1 text-sm font-medium transition-colors hover:text-primary-500 whitespace-nowrap ${
                  location.pathname.startsWith('/category') ? 'text-primary-500' : 'text-foreground-700'
                }`}
              >
                分类浏览
                <i className={`ri-arrow-down-s-line text-xs transition-transform ${categoryOpen ? 'rotate-180' : ''}`}></i>
              </button>
              {categoryOpen && (
                <div className="absolute top-full left-0 mt-2 w-56 bg-background-50 rounded-lg shadow-lg border border-background-200 py-2 z-50">
                  {categories.map((cat) => (
                    <Link
                      key={cat.slug}
                      to={`/category/${cat.slug}`}
                      className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-500 transition-colors"
                    >
                      <span className="w-8 h-8 flex items-center justify-center">
                        <i className={`${cat.icon} text-base`}></i>
                      </span>
                      <span>{cat.name}</span>
                      <span className="ml-auto text-xs text-foreground-400">{cat.count}</span>
                    </Link>
                  ))}
                </div>
              )}
            </div>

            <Link
              to="/about"
              className={`text-sm font-medium transition-colors hover:text-primary-500 whitespace-nowrap ${
                location.pathname === '/about' ? 'text-primary-500' : 'text-foreground-700'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className="w-9 h-9 flex items-center justify-center rounded-full hover:bg-background-100 transition-colors cursor-pointer" aria-label="搜索">
              <i className="ri-search-line text-foreground-600"></i>
            </button>
            <Link
              to="/about"
              className="px-5 py-2 bg-primary-500 text-background-50 text-sm font-medium rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              联系我们
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-full hover:bg-background-100 transition-colors cursor-pointer"
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-foreground-700`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 shadow-lg">
          <div className="px-4 py-3 space-y-1">
            <Link to="/" className="block px-3 py-2.5 text-sm font-medium text-foreground-700 hover:text-primary-500 rounded-lg hover:bg-background-100 transition-colors">首页</Link>
            <div className="px-3 py-2.5 text-sm font-medium text-foreground-500">分类浏览</div>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="flex items-center gap-3 pl-6 pr-3 py-2 text-sm text-foreground-600 hover:text-primary-500 rounded-lg hover:bg-background-100 transition-colors"
              >
                <span className="w-6 h-6 flex items-center justify-center">
                  <i className={`${cat.icon} text-sm`}></i>
                </span>
                {cat.name}
              </Link>
            ))}
            <Link to="/about" className="block px-3 py-2.5 text-sm font-medium text-foreground-700 hover:text-primary-500 rounded-lg hover:bg-background-100 transition-colors">关于我们</Link>
            <Link to="/about" className="block w-full text-center px-3 py-2.5 bg-primary-500 text-background-50 text-sm font-medium rounded-full hover:bg-primary-600 transition-colors mt-3">联系我们</Link>
          </div>
        </div>
      )}
    </nav>
  );
}